module.exports = __webpack_public_path__ + "static/media/empty-user.3f7a4988.svg";